import { css } from 'styled-components';

interface Colors {
  navyBlue: string;
  white: string;
  black: string;

  peach: string;
  green: string;
  greenLight: string;
  teal: string;
  forestGreen: string;

  error: string;
  transparent: string;

  grey: string;
  greyLight: string;
  utilityBlue: string;
}

export const colors: Colors = {
  navyBlue: '#26313B',
  white: '#fff',
  black: '#000',

  peach: '#FFCFAD',
  green: '#B1CB8F',
  greenLight: '#EBF8F2',
  teal: '#BAE1D1',
  forestGreen: '#4F5950',

  error: '#F56E43',
  transparent: 'transparent',

  grey: '#E4E4E4',
  greyLight: 'F8F8F8',
  utilityBlue: '#1446C5',
};

export interface ColorStyleProps {
  color?: string;
}

export const colorStyle = css<ColorStyleProps>`
  color: ${({ color = colors.navyBlue }) => color};
`;
